import React, { CSSProperties, ReactNode } from 'react';
import styles from './BasePageLayout.module.scss';
import Breadcrumbs from '../Breadcrumbs/Breadcrumbs';
import { cx } from '@emotion/css';
import { BreadcrumbType } from '../../../admin/hooks/useAdminProjectBreadcrumbs';

export interface BasePageLayoutProps {
    id?: string;
    breadcrumbs?: BreadcrumbType[];
    heading?: string;
    headingContent?: ReactNode;
    classNames?: { layout?: string; head?: string };
    children?: ReactNode;
    style?: CSSProperties;
}

export default function BasePageLayout(props: BasePageLayoutProps) {
    const {
        id,
        breadcrumbs,
        heading,
        headingContent,
        children,
        classNames = {},
        style,
    } = props;

    return (
        <div
            id={id}
            className={cx(styles.layout, classNames?.layout)}
            style={style}
        >
            {!!breadcrumbs && <Breadcrumbs steps={breadcrumbs} />}
            {(!!heading || !!headingContent) && (
                <div className={cx(styles.head, classNames?.head)}>
                    {!!heading && <h5>{heading}</h5>}
                    {headingContent}
                </div>
            )}
            {children}
        </div>
    );
}
